module.exports = __webpack_public_path__ + "public/img/xcs-5.2c4a46e2.jpg";